import React, { useState } from "react";
import { Select } from "antd";
import CatAreaWiseSaleReport from "./category-areawise-sales";
import SubCatAreaWiseSaleReport from "./subcategory-areawise-sales";
import AreawiseInvoice from "./areawise-invoice";
import ItemAreaWiseSaleReport from "./item-areawise-sales-report";

const { Option } = Select;

export default function AreaWise() {
  const [selectOption, setSelectOption] = useState("");
  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Area Based Reports</h2>
            </div>
            <div className="col-md-6">
              <div>
                <label htmlFor="">Select a Report</label>
              </div>
              <Select
                className="form-control"
                placeholder="Select a Report"
                onChange={(value) => setSelectOption(value)}
              >
                <Option value="1">Category wise Sales Report</Option>
                <Option value="2">Sub Category wise Sales Report</Option>
                <Option value="3">Invoice</Option>
                <Option value="4">Item wise Sales</Option>
              </Select>
            </div>
          </div>
        </div>
      </div>

      {selectOption === "1" && <CatAreaWiseSaleReport />}
      {selectOption === "2" && <SubCatAreaWiseSaleReport />}
      {selectOption === "3" && <AreawiseInvoice />}
      {selectOption === "4" && <ItemAreaWiseSaleReport />}
    </div>
  );
}
